module.exports = __webpack_public_path__ + "img/testimonials-stars.fa33cf69.svg";